import { MapPin, Phone, MessageCircle, Mail } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { ADDRESS, PHONE_TEL, PHONE_DISPLAY, WA_LINK, EMAIL } from "./data";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="bg-[#071009] py-20 lg:py-32">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow>Reach Us</Eyebrow>
        <h2 className="font-display mt-4 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="contact-heading">
          Contact KARM INDUSTRIES
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
        <Reveal>
          <div className="flex h-full flex-col rounded-2xl border border-emerald-500/15 bg-[#0B150F] p-8" data-testid="contact-address-card">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-950 text-emerald-400">
              <MapPin className="h-6 w-6" />
            </div>
            <h3 className="font-display mt-5 text-xl font-bold text-white">KARM INDUSTRIES</h3>
            <p className="mt-3 leading-relaxed text-slate-300">
              Plot No. 41, Amkuhi Industrial Area,<br />
              Katni, Madhya Pradesh, India
            </p>
            <p className="mt-auto pt-6 font-mono2 text-xs uppercase tracking-widest text-slate-500">
              buybiopellets.com
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-6">
          <Reveal delay={0.1}>
            <div className="flex items-center justify-between gap-4 rounded-2xl border border-emerald-500/15 bg-[#0B150F] p-6" data-testid="contact-phone-card">
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-950 text-emerald-400">
                  <Phone className="h-5 w-5" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-widest text-slate-500">Phone / Call</p>
                  <p className="font-mono2 text-lg font-bold text-white">{PHONE_DISPLAY}</p>
                </div>
              </div>
              <a href={PHONE_TEL} data-testid="contact-call-button" className="rounded-full bg-emerald-500 px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-[#050B07] transition-colors hover:bg-emerald-400">
                Call
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.18}>
            <div className="flex items-center justify-between gap-4 rounded-2xl border border-emerald-500/15 bg-[#0B150F] p-6" data-testid="contact-whatsapp-card">
              <div className="flex items-center gap-4">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-950 text-emerald-400">
                  <MessageCircle className="h-5 w-5" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-widest text-slate-500">WhatsApp</p>
                  <p className="font-mono2 text-lg font-bold text-white">{PHONE_DISPLAY}</p>
                </div>
              </div>
              <a href={WA_LINK} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-button" className="rounded-full border border-emerald-500/50 px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-emerald-300 transition-colors hover:bg-emerald-500 hover:text-[#050B07]">
                Chat
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.26}>
            <div className="flex items-center justify-between gap-4 rounded-2xl border border-emerald-500/15 bg-[#0B150F] p-6" data-testid="contact-email-card">
              <div className="flex min-w-0 items-center gap-4">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-950 text-emerald-400">
                  <Mail className="h-5 w-5" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs uppercase tracking-widest text-slate-500">Email</p>
                  <p className="truncate font-mono2 text-sm font-bold text-white sm:text-base">{EMAIL}</p>
                </div>
              </div>
              <a href={`mailto:${EMAIL}`} data-testid="contact-email-button" className="shrink-0 rounded-full border border-white/25 px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:bg-white/10">
                Mail
              </a>
            </div>
          </Reveal>
        </div>
      </div>
      <p className="sr-only">{ADDRESS}</p>
    </div>
  </section>
);
